"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
class DMSMessageFactory {
}
exports.default = DMSMessageFactory;
DMSMessageFactory.newMessage = (method, payload, targetNode) => {
    return {
        id: index_1.Util.generateNewId(),
        method,
        payload,
        targetNode
    };
};
DMSMessageFactory.newNotification = (method, payload, targetNode) => {
    return {
        method,
        payload,
        targetNode
    };
};
DMSMessageFactory.createReply = (message, payload) => {
    return {
        id: message.id,
        error: message.error,
        payload,
    };
};
//# sourceMappingURL=DMSMessageFactory.js.map